module.exports = __webpack_public_path__ + "img/4.414781e7.jpg";